import { parseISO, format } from 'date-fns';
import { it } from 'date-fns/locale';

export default {
  methods: {
    formatDateTime(dateTimeString) {
      const date = parseISO(dateTimeString);
      return format(date, 'dd/MM/yyyy HH:mm', { locale: it });
    },
    formatDate(dateTimeString) {
        const date = parseISO(dateTimeString);
        return (format(date, 'dd/MM/yyyy HH:mm', { locale: it })).substring(0, 10);
      }
  }
};
